import { IntegrationState } from "../types";

const state: IntegrationState = {
  publicKey: "",
  secretKey: "",
};

export default state;
